import { BlurEvent, ClickEvent, DataSourceExecutionEvent, Layout, ScreenStack, Snackbar } from "@mcleod/components";
import { Api, HorizontalAlignment, Navigation } from "@mcleod/core";
import { AutogenLayoutAssignCarrierPlanPrompt } from "@mcleod/crm/src/autogen/AutogenLayoutAssignCarrierPlanPrompt";
import { ModelCarrierPlan } from "@mcleod/crm";
import { CommonDialogs } from "@mcleod/common";

export class AssignCarrierPlanPrompt extends AutogenLayoutAssignCarrierPlanPrompt {
    async sourceDrsPayeeAfterExecution(event: DataSourceExecutionEvent) {
        if (!this.activeRow.isNull("drs_payee.mark_plan_id")) {
            const carrierPlan = await new ModelCarrierPlan().searchSingle({ id: this.activeRow.get("drs_payee.mark_plan_id") });
            this.activeRow.setLookupModelData("drs_payee.mark_plan_id", carrierPlan);
            this.mainDataSource.displayDataInBoundComponent(this.textboxDrsPayeemarkPlanId);
        }
        this.activeRow.set("drs_payee.start_date", new Date());
        this.textboxContact.required = !this.activeRow.isNull("drs_payee.mark_plan_id");
    }

    textboxMarkPlanIdOnBlur(event: BlurEvent) {
        this.textboxContact.required = !this.activeRow.isNull("drs_payee.mark_plan_id");
    }

    static showModal(payeeId: string) {
        const layout = Layout.getLayout("lme/crm/AssignCarrierPlanPrompt") as AssignCarrierPlanPrompt;
        layout.addLayoutDataLoadListener(async event => {
            await layout.mainDataSource.search({ id: payeeId });
            layout.textboxContact.addBeforeLookupModelSearchListener(event => {
                if (payeeId == null) {
                    event.preventDefault();
                } else {
                    event.filter.parent_row_id = payeeId;
                    event.filter.parent_row_type = "P";
                }
            });
        });

        CommonDialogs.showYesNo(layout, "Assign Carrier Plan", {
            width: 400,
            panelTitleProps: { backgroundColor: "primary.darker", color: "primary.reverse" },
            panelContentProps: { align: HorizontalAlignment.CENTER },
            noButtonCaption: "Cancel",
            yesButtonProps: { caption: "Assign", backgroundColor: 'primary', color: 'default.reverse', onClick: async (event: ClickEvent) => {
                if (!layout.validateSimple()) {
                    event.preventDefault();
                    return;
                }
                const progressSnackbar = Snackbar.showDownloadSnackbar("Action In Progress", "Assigning Carrier Plan...", {
                    targetPanel: ScreenStack.getPreviousSnackbarTarget(), persist: true
                });
                const body = {
                    "payee_id": payeeId,
                    "salesperson_id": layout.activeRow.get("drs_payee.salesperson_id", null),
                    "carrier_plan_id": layout.activeRow.get("drs_payee.mark_plan_id", null),
                    "start_date": layout.activeRow.getDate("drs_payee.start_date", null),
                    "contact_name": layout.textboxContact.text
                }
                Api.post("lme/crm/assign-carrier-plan", body)
                .then(() => Navigation.reloadCurrentPage())
                .catch((err) => Snackbar.showWarningSnackbar("Failed to assign carrier plan: " + err.messages[0]))
                .finally(() => progressSnackbar.dismiss());
            }}
        });
    }
}